import React from 'react'
import PropTypes from 'prop-types'

/**
 * Componente Avatar que muestra una imagen o las iniciales del usuario dentro de un círculo colorido
 */
function Avatar({ src, initials, variant = 'primary', size = 'md', className = '' }) {
    // Mapear tamaños a dimensiones reales
    const sizeMap = {
        sm: {
            width: '60px',
            height: '60px',
            fontSize: '1.25rem'
        },
        md: {
            width: '80px',
            height: '80px',
            fontSize: '1.75rem'
        },
        lg: {
            width: '120px',
            height: '120px',
            fontSize: '2.5rem'
        }
    }

    const dimensions = sizeMap[size] || sizeMap.md

    const styles = {
        avatar: {
            width: dimensions.width,
            height: dimensions.height,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            backgroundColor: src ? 'transparent' : `var(--bs-${variant})`, // No background if image
            color: 'white',
            fontSize: dimensions.fontSize,
            fontWeight: 'bold',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            objectFit: 'cover', // For images
        },
        text: {
            letterSpacing: '1px'
        }
    }

    return (
        <div className={`avatar-circle ${className}`} style={styles.avatar}>
            {src ? (
                <img
                    src={src}
                    alt="Avatar"
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        objectFit: 'cover'
                    }}
                />
            ) : (
                <span className="avatar-text" style={styles.text}>
                    {initials || '??'}
                </span>
            )}
        </div>
    )
}

Avatar.propTypes = {
    /** URL de la imagen del avatar (opcional) */
    src: PropTypes.string,
    /** Iniciales a mostrar (normalmente 2 letras) */
    initials: PropTypes.string,
    /** Variante de color de Bootstrap (primary, success, danger, etc.) */
    variant: PropTypes.string,
    /** Tamaño del avatar: 'sm', 'md', o 'lg' */
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    /** Clases CSS adicionales */
    className: PropTypes.string
}

export default Avatar